<script>
import Button from "@/components/Button.vue";
import RoomPlayer from '@/components/RoomPlayer';
import FBApp from "@/library/firebase";
import Utils from "@/library/utils";
import RoomStore from '@/store/room';
import {toast} from "vue3-toastify";

const {logEvents} = FBApp;

export default {
  name: "RoomPlayers",

  components: {
    Button,
    RoomPlayer
  },

  props: {
    isOwner: Boolean,
  },

  data: () => ({
    hasShare: false,
    userScore: []
  }),

  watch: {
    scores: {
      deep: true,
      immediate: true,
      handler(scores) {
        scores?.forEach(score => {
          this.userScore[score.player_id] = score
        })
      }
    }
  },

  computed: {
    players() {
      return RoomStore.players || [];
    },

    adminPlayer(){
      return this.players.find(p=>p.user_id === RoomStore.room?.user_id);
    },

    otherPlayer(){
      return this.players.filter(p=>p.user_id !== RoomStore.room?.user_id).sort((a,b) => a.created_at - b.created_at );
    },

    scores() {
      return RoomStore.scores;
    },

    timer() {
      return RoomStore.timer?.timeFormatted
    },

    storyStarted() {
      return RoomStore.activeStory?.started_at
    },

    storyCompleted() {
      return RoomStore.activeStory?.completed_at
    },

    completedAt() {
      const startTime = this.storyStarted;
      const endTime = this.storyCompleted;

      if (!startTime || !endTime) {
        return '-';
      }

      const elapsedMilliseconds = new Date(startTime) - new Date(endTime);
      return Utils.getFormattedTime(Math.floor(Math.abs(elapsedMilliseconds) / 1000));
    },

    pageUrl() {
      const {origin, pathname }= window.location;
      return `${origin}${pathname}`;
    },
  },
  methods: {
    copyUrl() {
      navigator.clipboard.writeText(this.pageUrl);
      toast.success('URL copied to clipboard');
      logEvents('Copy Room Link')
    }
  },
}
</script>

<template>
  <div
      class="flex flex-col border border-gray-300 py-4 bg-white mx-4 max-w-42 flex-base max-sm:w-full max-sm:mx-auto dark:border-dark-border dark:bg-dark-modal"
      :class="`${isOwner?'rounded':'rounded-b border-t-0'}`"
  >
    <div class="flex justify-between items-center px-4 mb-2">
      <span class="text-xl font-smiebold text-gray-700 dark:text-dark-text">Players : </span>
      <span class="font-semibold text-blue-500 text-xl dark:text-dark-text">
        <template v-if="storyStarted && !storyCompleted">{{ timer }}</template>
        <template v-if="storyCompleted">{{ completedAt }}</template>
      </span>
    </div>
    <ul class="flex flex-col" :key="`player-${userScore?.length}`">
      <li class="p-4 border-b border-b-gray-300 dark:border-dark-border admin-player">
        <room-player :player="adminPlayer" :key="adminPlayer.id" :score="userScore?.[adminPlayer.id]"/>
      </li>
      <li v-for="player in otherPlayer" class="p-4 border-b border-b-gray-300 dark:border-dark-border">
        <room-player :player="player" :key="player.id" :score="userScore?.[player.id]"/>
      </li>
    </ul>

    <div class="flex flex-col w-full">
      <button class="flex w-full justify-between items-center p-4 pb-0 dark:text-dark-text"
              @click="hasShare = !hasShare"
      >
        <span class="text-md font-semibold text-gray-500 dark:text-dark-text">
          Invite a teammate
        </span>
        <svg data-v-b72c1b0c="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                d="m14.5 8.5-4 4-4-4">
          </path>
        </svg>
      </button>
      <div class="flex w-full gap-2 justify-between items-center p-4 max-sm:flex-col" v-if="hasShare">
        <input id="room-url"
               type="url"
               v-tooltip="{ content: 'Click to copy',shown: true, triggers: ['hover', 'focus', 'active', 'click'], html: true }"
               :value="pageUrl"
               @click="copyUrl"
               readonly
               class="border cursor-pointer select-none border-gray-200 rounded p-2 flex-grow me-1 max-sm:w-full dark:border-dark-border dark:text-dark-text">
      </div>
    </div>
  </div>
</template>
